import { QRCodeLoginCancel, QRCodeLoginConfirm, QRCodeLoginScan } from "@/apis/user";
import { DialogLocal } from "@/components/Dialog";
import { Toast } from "antd-mobile";
import { decode } from "js-base64";
import { NavigateFunction } from "react-router-dom";
import { LINK_ACCOUNT_TOKEN } from "@/constants";
import { UserInfo } from "@/types/Api/User/MyAccount/userInfo";

/* “decodeScheme”函数是一个 TypeScript 函数，它使用“js-base64”库解码给定的编码文本。它需要三个参数：“encodedText”、“token”和“navigate”。 */
export const decodeScheme = async (encodedText: string, token: string | UserInfo["response"], navigate: NavigateFunction) => {
  if (!encodedText) return Toast.show("解析失败");
  try {
    const _decodeText = decode(encodedText.replace("vppal://", ""));
    const [type, content] = _decodeText.split("?");
    if (type === "payOrder") {
      // const [kvOrder, kvAmount] = content.split("&");
      // const [, order] = kvOrder.split("=");
      // const [, amount] = kvAmount.split("=");
      // 跳转支付页面
      // if (!token) return;
      // return navigate(`/pay_order?orderNo=${order}&amount=${amount}`);
      return navigate(`/pay_order?${content}`);
    }
    if (type === "login") {
      const [, UUID] = content.split("=");
      // 扫码登陆
      if (!token) return;
      const response = await QRCodeLoginScan({
        uuid: UUID
      });
      if (response.ok) {
        DialogLocal({
          title: "新设备登录确认",
          confirmText: "确认登录",
          cancelText: "取消登录",
          content: <p>
              您有新的设备:
              <span style={{
              color: "rgb(240, 83, 95)"
            }}>
                ${response.data.deviceModel} ${response.data.operatingSystem}
              </span>
              将登录账号:
              <span style={{
              color: "rgb(240, 83, 95)"
            }}>
                ${response.data.scannedUserNickname}
              </span>
              ,请确认是否登录新设备。
            </p>,
          async onConfirm() {
            const response = await QRCodeLoginConfirm({
              uuid: UUID
            });
            if (response.ok) {
              Toast.show(response.msg);
            } else {
              Toast.show(response.msg);
            }
            return true;
          },
          async onCancel() {
            const response = await QRCodeLoginCancel({
              uuid: UUID
            });
            if (response.ok) {
              Toast.show(response.msg);
            } else {
              Toast.show(response.msg);
            }
            return true;
          }
        });
      } else {
        Toast.show(response.msg);
      }
      return;
    }
    if (type === "link") {
      const search = new URLSearchParams(content);
      if (search.get('auth')) {
        window.localStorage[LINK_ACCOUNT_TOKEN] = search.get('auth');
        return navigate('/link_account');
      }
    }
    await DialogLocal({
      title: "扫描内容",
      content: `decode text:${_decodeText}`
    });
  } catch (error) {
    // TODO report error
    console.error(error);
    await DialogLocal({
      title: "提示",
      content: `无效二维码`
    });
  }
};